import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { TrendValue, TrendValueEnum } from 'src/app/shared/models/trend-value.model';

@Component({
  selector: 'app-trend-indicator',
  templateUrl: './trend-indicator.component.html',
  styleUrls: ['./trend-indicator.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, MatIconModule],
})
export class TrendIndicatorComponent {
  @Input() trend: TrendValue = TrendValueEnum.Neutral;
  @Input() trendText = '';
  @Input() periodLabel = '';
  @Input() hasInsufficientData = false;

  constructor(private translateService: TranslateService) {}

  getTrendClass(): string {
    return 'trend-' + this.trend.replace(/\s+/g, '-');
  }

  getTrendIconClass(): string {
    return 'trend-icon-' + this.trend.replace(/\s+/g, '-');
  }

  getTranslatedPeriodLabel(): string {
    if (!this.periodLabel) {
      return '';
    }
    return this.translateService.instant(this.periodLabel).toLowerCase();
  }
}
